module.exports = __webpack_public_path__ + "img/number_1.54500a7e.svg";